let authToken: string | undefined

export const setAuthToken = (value?: string) => {
  authToken = value
}

export const getAuthToken = () => {
  return authToken
}
